module.exports = __webpack_public_path__ + "img/logo-unifael-preta.1a31261d.png";